import { LinkOpenIcon } from '@thefarmersfront/kitchen';

import type { ColDef, ICellRendererParams } from 'ag-grid-community';

import { TextButtonCell } from '~/components/common';

import type { TypeOrderDetailDeliveryInfoData } from '~/types/order.types';

/**
 * [출고주문관리 > 출고 주문 상세] '배송 정보' 테이블
 */
const getOrderDetailDeliveryInfoColumnDefs = () => {
  const columnDefs: ColDef<TypeOrderDetailDeliveryInfoData>[] = [
    {
      field: 'invoiceNumber',
      headerName: '송장번호',
      width: 240,
    },
    {
      field: 'operation',
      headerName: '배송유형',
      width: 80,
    },
    {
      field: 'courier',
      headerName: '배송사',
      width: 88,
    },
    {
      field: 'deliveryStatus',
      headerName: '배송상태',
      width: 100,
    },
    {
      field: 'url',
      headerName: '',
      minWidth: 240,
      flex: 1,
      cellRenderer: TextButtonCell,
      cellRendererParams: ({
        value,
      }: ICellRendererParams<TypeOrderDetailDeliveryInfoData, TypeOrderDetailDeliveryInfoData['url']>) => ({
        children: '배송조회',
        size: 'tiny',
        target: '_blank',
        href: value,
        rightIcon: <LinkOpenIcon size={16} color="#672091" />,
      }),
      cellStyle: { display: 'flex', alignItems: 'center' },
    },
  ];

  return { columnDefs };
};

export default getOrderDetailDeliveryInfoColumnDefs;
